const SCRIPT_ID = 'proven-turnstile-script';
const CONTAINER_ID = 'proven-turnstile-container';

let configPromise;
let scriptPromise;
let widgetId;
let pendingRequest;

const getSiteKey = async () => {
  if (!configPromise) {
    configPromise = fetch('/api/config', { headers: { Accept: 'application/json' } })
      .then((response) => {
        if (!response.ok) throw new Error('Verification is unavailable.');
        return response.json();
      })
      .then((config) => {
        if (!config.turnstileSiteKey) throw new Error('Verification is unavailable.');
        return config.turnstileSiteKey;
      });
  }
  return configPromise;
};

const loadScript = () => {
  if (window.turnstile) return Promise.resolve(window.turnstile);
  if (scriptPromise) return scriptPromise;

  scriptPromise = new Promise((resolve, reject) => {
    const existing = document.getElementById(SCRIPT_ID);
    const script = existing || document.createElement('script');
    script.id = SCRIPT_ID;
    script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
    script.async = true;
    script.defer = true;
    script.onload = () => resolve(window.turnstile);
    script.onerror = () => reject(new Error('Verification could not be loaded.'));
    if (!existing) document.head.appendChild(script);
  });
  return scriptPromise;
};

const getContainer = () => {
  let container = document.getElementById(CONTAINER_ID);
  if (!container) {
    container = document.createElement('div');
    container.id = CONTAINER_ID;
    container.style.position = 'fixed';
    container.style.right = '16px';
    container.style.bottom = '16px';
    container.style.zIndex = '2147483647';
    document.body.appendChild(container);
  }
  return container;
};

export const getTurnstileToken = async () => {
  const [sitekey, turnstile] = await Promise.all([getSiteKey(), loadScript()]);

  return new Promise((resolve, reject) => {
    if (pendingRequest) {
      pendingRequest.reject(new Error('A verification is already in progress.'));
    }
    pendingRequest = { resolve, reject };

    const complete = (method, value) => {
      const request = pendingRequest;
      pendingRequest = undefined;
      if (request) request[method](value);
    };
    const options = {
      sitekey,
      action: 'contact',
      execution: 'execute',
      appearance: 'interaction-only',
      callback: (token) => complete('resolve', token),
      'error-callback': () => complete('reject', new Error('Verification failed. Please try again.')),
      'expired-callback': () => complete('reject', new Error('Verification expired. Please try again.')),
      'timeout-callback': () => complete('reject', new Error('Verification timed out. Please try again.')),
    };

    try {
      if (widgetId === undefined) {
        widgetId = turnstile.render(getContainer(), options);
      }
      turnstile.reset(widgetId);
      turnstile.execute(widgetId);
    } catch (error) {
      complete('reject', error);
    }
  });
};
